/*
  DARK MATTER — HESITATION TAX ENGINE v4
  ========================================
  - Ascending floor reset cycles (floor +50% each cycle)
  - Ceiling fixed per product
  - When floor >= ceiling: specimen ARCHIVES permanently
  - Counter persists across page refreshes
  - Per-product config via Shopify metafield custom.drop_config
*/

const DM_DEFAULTS = {
  apiUrl:                'https://darkmatter-api-amber.vercel.app/api/freeze',
  checkoutWindowSeconds: 60,
  mountTargetId:         'product-form',
  floorMultiplier:       1.5,
};

(function () {
  'use strict';

  const productConfig = window.DM_PRODUCT_CONFIG || null;
  let baseFloor, ceiling, ratePerHour, dropId, variantId, productId;

  if (productConfig) {
    dropId      = productConfig.dropId      || String(productConfig.productId || 'default');
    variantId   = productConfig.variantId;
    productId   = productConfig.productId;
    baseFloor   = productConfig.floor       || 150;
    ceiling     = productConfig.ceiling     || 5000;
    ratePerHour = productConfig.ratePerHour || 50;
  } else {
    dropId      = 'default-drop';
    variantId   = '';
    productId   = '';
    baseFloor   = 150;
    ceiling     = 5000;
    ratePerHour = 50;
  }

  const LS_KEY = 'dm_drop_' + dropId;
  function getDropState() { try { const r = localStorage.getItem(LS_KEY); return r ? JSON.parse(r) : null; } catch(e) { return null; } }
  function saveDropState(s) { try { localStorage.setItem(LS_KEY, JSON.stringify(s)); } catch(e) {} }
  function initDropState() { let s = getDropState(); if (!s) { s = { dropStartTime: Date.now(), dropId }; saveDropState(s); } return s; }

  const dropStart = initDropState().dropStartTime;

  function getCycleFloor(i) { return Math.round(baseFloor * Math.pow(DM_DEFAULTS.floorMultiplier, i)); }
  function getCycleDuration(i) { const f = getCycleFloor(i); return f >= ceiling ? 0 : (ceiling - f) / (ratePerHour / 3600); }

  function computeCurrentState() {
    let elapsed = (Date.now() - dropStart) / 1000;
    let i = 0;
    while (true) {
      const floor = getCycleFloor(i);
      const dur   = getCycleDuration(i);
      if (floor >= ceiling || dur <= 0) return { archived: true, cycleIndex: i, price: ceiling, floor: ceiling, pct: 100, cycleNumber: i + 1, nextFloor: ceiling };
      if (elapsed <= dur) {
        const price = floor + (ratePerHour / 3600) * elapsed;
        const pct   = Math.min(100, ((price - floor) / (ceiling - floor)) * 100);
        return { archived: false, cycleIndex: i, price: Math.min(price, ceiling), floor, pct, cycleNumber: i + 1, nextFloor: getCycleFloor(i + 1) };
      }
      elapsed -= dur;
      i++;
    }
  }

  let frozen = false, frozenPrice = null, checkoutExpiry = null, tickInterval = null, countdownInterval = null;

  function fmt(p) { return '$' + parseFloat(p).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function fmtMs(ms) { const s = Math.max(0, Math.floor(ms / 1000)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }
  function $(id) { return document.getElementById(id); }

  function tick() {
    if (frozen) return;
    const state = computeCurrentState();
    if (state.archived) { updateUI('archived', state); clearInterval(tickInterval); return; }
    updateUI('running', state);
  }

  function updateUI(mode, state) {
    if (!$('dm-price')) return;
    if (mode === 'running') {
      $('dm-price').textContent = fmt(state.price);
      $('dm-price').classList.add('dm-tick');
      setTimeout(() => $('dm-price') && $('dm-price').classList.remove('dm-tick'), 80);
      $('dm-rate').textContent         = '+' + fmt(ratePerHour / 3600) + '/sec  ·  CYCLE ' + state.cycleNumber;
      $('dm-bar').style.width          = state.pct.toFixed(1) + '%';
      $('dm-floor-val').textContent    = fmt(state.floor);
      $('dm-ceiling-val').textContent  = fmt(ceiling);
      $('dm-nextfloor-val').textContent = fmt(state.nextFloor);
      $('dm-status').textContent       = '● PRICE ACTIVE';
    }
    if (mode === 'archived') {
      $('dm-price').textContent  = fmt(ceiling);
      $('dm-price').style.color  = '#555';
      $('dm-rate').textContent   = 'This specimen has closed.';
      $('dm-bar').style.width    = '100%';
      $('dm-status').textContent = '◉ ARCHIVED';
      $('dm-status').style.color = '#555';
      ['dm-freeze-btn','dm-info-block','dm-disclaimer'].forEach(id => { const el = $(id); if (el) el.style.display = 'none'; });
      const arch = $('dm-archived-block'); if (arch) arch.style.display = 'block';
    }
    if (mode === 'frozen') {
      $('dm-freeze-btn').disabled    = true;
      $('dm-freeze-btn').textContent = 'FREEZING PRICE...';
      $('dm-status').textContent     = '◉ CONTACTING SERVER';
    }
    if (mode === 'locked') {
      $('dm-freeze-btn').style.display     = 'none';
      $('dm-checkout-block').style.display = 'block';
      $('dm-frozen-price').textContent     = fmt(frozenPrice);
      $('dm-status').textContent           = '◉ PRICE LOCKED';
    }
    if (mode === 'expired') {
      $('dm-checkout-block').style.display = 'none';
      $('dm-freeze-btn').style.display     = 'block';
      $('dm-freeze-btn').disabled          = false;
      $('dm-freeze-btn').textContent       = 'FREEZE PRICE — BUY NOW';
      $('dm-status').textContent           = '● PRICE ACTIVE';
      frozen = false; frozenPrice = null;
    }
  }

  async function handleFreeze() {
    if (frozen) return;
    frozen = true;
    const state = computeCurrentState();
    frozenPrice = state.price;
    updateUI('frozen');
    try {
      const res = await fetch(DM_DEFAULTS.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ price: frozenPrice.toFixed(2), variantId: String(variantId), productId: String(productId), productTitle: document.title || 'SPECIMEN' }),
      });
      if (!res.ok) throw new Error('API ' + res.status);
      const data = await res.json();
      $('dm-checkout-btn').dataset.url = data.checkoutUrl;
      checkoutExpiry = Date.now() + 60 * 1000;
      updateUI('locked');
      startCountdown();
    } catch(err) {
      console.error('DM freeze error:', err);
      frozen = false; frozenPrice = null;
      const btn = $('dm-freeze-btn');
      if (btn) { btn.disabled = false; btn.textContent = 'FREEZE PRICE — BUY NOW'; }
      const st = $('dm-status'); if (st) st.textContent = '⚠ ERROR — TRY AGAIN';
    }
  }

  function startCountdown() {
    if (countdownInterval) clearInterval(countdownInterval);
    countdownInterval = setInterval(() => {
      const rem = checkoutExpiry - Date.now();
      const el = $('dm-countdown'); if (el) el.textContent = fmtMs(rem);
      if (rem <= 0) { clearInterval(countdownInterval); updateUI('expired'); }
    }, 500);
  }

  function handleCheckout() {
    const btn = $('dm-checkout-btn');
    if (btn && btn.dataset.url) window.location.href = btn.dataset.url;
  }

  function injectStyles() {
    if ($('dm-styles')) return;
    const s = document.createElement('style');
    s.id = 'dm-styles';
    s.textContent = `
      #dm-widget{margin:24px 0;font-family:'Space Mono',monospace}
      .dm-wrap{border:.5px solid #2a2a2a;padding:20px;background:#000;color:#fff}
      .dm-header-row{display:flex;justify-content:space-between;align-items:center;margin-bottom:16px}
      .dm-label{font-size:11px;letter-spacing:.3em;color:#aaa;text-transform:uppercase}
      .dm-status{font-size:11px;letter-spacing:.2em;color:#aaa}
      .dm-price{font-size:42px;font-weight:700;letter-spacing:-.02em;line-height:1;margin-bottom:6px;transition:color .08s}
      .dm-price.dm-tick{color:#cc2200}
      .dm-rate{font-size:12px;letter-spacing:.12em;color:#ccc;margin-bottom:16px}
      .dm-bar-track{height:1px;background:#1a1a1a;margin-bottom:16px}
      .dm-bar{height:100%;background:#cc2200;transition:width .5s linear}
      .dm-info-block{margin-bottom:20px}
      .dm-info-row{display:flex;justify-content:space-between;align-items:center;padding:8px 0;border-bottom:.5px solid #1a1a1a}
      .dm-info-row:last-child{border-bottom:none}
      .dm-info-label{font-size:10px;letter-spacing:.2em;color:#666;text-transform:uppercase}
      .dm-info-value{font-size:13px;letter-spacing:.05em;color:#fff;font-weight:700}
      .dm-info-value.highlight{color:#cc2200}
      .dm-freeze-btn{width:100%;background:#fff;color:#000;border:none;padding:14px 20px;font-family:inherit;font-size:11px;letter-spacing:.2em;text-transform:uppercase;cursor:pointer;margin-bottom:12px}
      .dm-freeze-btn:hover{background:#ddd}
      .dm-freeze-btn:disabled{background:#1a1a1a;color:#444;cursor:not-allowed}
      .dm-checkout-block{border:.5px solid #cc2200;padding:16px;margin-bottom:12px}
      .dm-frozen-label{font-size:11px;letter-spacing:.25em;color:#aaa;margin-bottom:4px;text-transform:uppercase}
      .dm-frozen-price{font-size:28px;font-weight:700;color:#fff;margin-bottom:12px}
      .dm-countdown-row{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px}
      .dm-countdown-label{font-size:11px;letter-spacing:.2em;color:#aaa;text-transform:uppercase}
      .dm-countdown{font-size:20px;font-weight:700;color:#cc2200;letter-spacing:.05em}
      .dm-checkout-btn{width:100%;background:#cc2200;color:#fff;border:none;padding:14px 20px;font-family:inherit;font-size:11px;letter-spacing:.2em;text-transform:uppercase;cursor:pointer}
      .dm-checkout-btn:hover{background:#aa1a00}
      .dm-archived-block{border:.5px solid #1a1a1a;padding:16px;margin-bottom:12px}
      .dm-archived-title{font-size:11px;letter-spacing:.3em;color:#555;margin-bottom:8px;text-transform:uppercase}
      .dm-archived-copy{font-size:11px;letter-spacing:.05em;color:#444;line-height:1.9}
      .dm-disclaimer{font-size:11px;letter-spacing:.05em;color:#888;line-height:1.9;margin-top:12px}
    `;
    document.head.appendChild(s);
  }

  function createWidgetEl() {
    const state = computeCurrentState();
    const arch  = state.archived;
    const w = document.createElement('div');
    w.id = 'dm-widget';
    w.innerHTML = `
      <div class="dm-wrap">
        <div class="dm-header-row">
          <span class="dm-label">⬡ HESITATION TAX</span>
          <span class="dm-status" id="dm-status">${arch ? '◉ ARCHIVED' : '● PRICE ACTIVE'}</span>
        </div>
        <div class="dm-price" id="dm-price" style="${arch ? 'color:#555' : ''}">${fmt(state.price)}</div>
        <div class="dm-rate"  id="dm-rate">${arch ? 'This specimen has closed.' : '+' + fmt(ratePerHour / 3600) + '/sec  ·  CYCLE ' + state.cycleNumber}</div>
        <div class="dm-bar-track"><div class="dm-bar" id="dm-bar" style="width:${state.pct.toFixed(1)}%"></div></div>

        <div class="dm-info-block" id="dm-info-block" style="${arch ? 'display:none' : ''}">
          <div class="dm-info-row">
            <span class="dm-info-label">Starting Floor</span>
            <span class="dm-info-value" id="dm-floor-val">${fmt(state.floor)}</span>
          </div>
          <div class="dm-info-row">
            <span class="dm-info-label">Ceiling</span>
            <span class="dm-info-value" id="dm-ceiling-val">${fmt(ceiling)}</span>
          </div>
          <div class="dm-info-row">
            <span class="dm-info-label">Next Floor Reset</span>
            <span class="dm-info-value highlight" id="dm-nextfloor-val">${fmt(state.nextFloor)}</span>
          </div>
        </div>

        ${!arch ? `<button class="dm-freeze-btn" id="dm-freeze-btn">FREEZE PRICE — BUY NOW</button>` : ''}

        <div class="dm-checkout-block" id="dm-checkout-block" style="display:none">
          <div class="dm-frozen-label">PRICE FROZEN AT</div>
          <div class="dm-frozen-price" id="dm-frozen-price">$—</div>
          <div class="dm-countdown-row">
            <span class="dm-countdown-label">EXPIRES IN</span>
            <span class="dm-countdown" id="dm-countdown">1:00</span>
          </div>
          <button class="dm-checkout-btn" id="dm-checkout-btn">COMPLETE PURCHASE</button>
        </div>

        <div class="dm-archived-block" id="dm-archived-block" style="${arch ? 'display:block' : 'display:none'}">
          <div class="dm-archived-title">SPECIMEN ARCHIVED</div>
          <div class="dm-archived-copy">This specimen has closed. It will not return.<br>It did not sell. It ascended.</div>
        </div>

        <div class="dm-disclaimer" id="dm-disclaimer" style="${arch ? 'display:none' : ''}">
          Price resets each cycle — floor rises 50%.<br>
          Freeze it. You have 60 seconds to checkout.<br>
          Hesitatation taxes your time accordingly.
        </div>
      </div>`;
    return w;
  }

  function buildWidget() {
    let target = document.getElementById(DM_DEFAULTS.mountTargetId);
    if (!target) {
      for (const id of ['MainProduct', 'product_form_template', 'shopify-section-main-product']) {
        const el = document.getElementById(id); if (el) { target = el; break; }
      }
    }
    if (!target) {
      const btn = document.querySelector('[name="add"]');
      if (btn && btn.parentNode) { btn.parentNode.insertBefore(createWidgetEl(), btn); return; }
      console.warn('DM: mount target not found'); return;
    }
    target.insertBefore(createWidgetEl(), target.firstChild);
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectStyles();
    buildWidget();

    // Event delegation — avoids timing issues with button binding
    document.addEventListener('click', function(e) {
      if (e.target && e.target.id === 'dm-freeze-btn')   handleFreeze();
      if (e.target && e.target.id === 'dm-checkout-btn') handleCheckout();
    });

    const state = computeCurrentState();
    if (!state.archived) { tickInterval = setInterval(tick, 100); tick(); }
  });

})();
